export default (props) => (
  <svg {...props} width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.757 36.2713C44.9891 27.7866 44.7366 14.2011 36.252 6.01949C27.7673 -2.21264 14.1818 -1.96012 6.00014 6.52453C-2.18148 15.0092 -1.97946 28.5947 6.50518 36.7763C14.9898 45.0085 28.5249 44.7559 36.757 36.2713Z"
      fill="#FEBE40" fill-opacity="0.2"/>
    <path d="M32 16.6667L21.5 22L11 16.6667V14H32V16.6667Z" fill="#666666"/>
    <path d="M11 18V30H32V18L21.5 23.3333L11 18Z" fill="#FFBE40"/>
    <path
      d="M9.73731 2.48421C9.98983 1.92867 9.78781 1.27212 9.23227 1.0196C8.67673 0.767078 8.02016 0.969094 7.76764 1.52464C7.51513 2.08018 7.71714 2.73673 8.27268 2.98925C8.82823 3.24177 9.48479 2.98925 9.73731 2.48421Z"
      fill="black" fill-opacity="0.03"/>
    <path
      d="M6.65678 36.4732C6.75779 35.9177 6.40425 35.4126 5.8487 35.3116C5.29316 35.2106 4.78813 35.5642 4.68712 36.1197C4.58611 36.6752 4.93963 37.1803 5.49517 37.2813C6.05071 37.3823 6.55578 37.0288 6.65678 36.4732Z"
      fill="black" fill-opacity="0.03"/>
  </svg>
)